import React from 'react'
import './MainPage.scss'

import Navbar from '../UI/Navbar/Navbar'

const mainPage = (props) => {
  return (
    <React.Fragment>
      <header className="mainPage" id="main">
        <Navbar {...props} />
        <h1 className="mainPage__title">Zakład kominiarski bieruń</h1>
      </header>
    </React.Fragment>
  )
}

export default mainPage
